import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-citi-shop-video',
  templateUrl: './citi-shop-video.component.html',
  styleUrls: ['./citi-shop-video.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CitiShopVideoComponent implements OnInit {
@Input() videoContent: any;
video: any;
isAudioEnabled= true;

ngOnInit(): void{
this.switchVideo();
}
switchVideo(event?: any){
  event?.preventDefault();
  if(this.videoContent){
    this.isAudioEnabled = !this.isAudioEnabled;
    this.video = this.videoContent?.video?.filter((t: any)=> (t.isAudioEnabled === this.isAudioEnabled.toString()))[0];    
  }
}
}
